import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "QuestionName",
    isNumber: true,
    isSum: true,
  },
];

export const CaseStatusToEyeDisease = {
  label: "案件狀態 VS 眼疾",
  key: "CaseStatusToEyeDisease",
  path: "FundusAbnormal/CaseStatusToEyeDisease",
  api: "TCS_V_EyesS01",
  render: (options) => (
    <Diagram.FundusAbnormal.CaseStatusToEyeDisease {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "CaseStatus",
      field: "CaseStatus",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
